import { render, staticRenderFns } from "./NeedSomething.vue?vue&type=template&id=75c98cba&"
import script from "./NeedSomething.vue?vue&type=script&lang=js&"
export * from "./NeedSomething.vue?vue&type=script&lang=js&"
import style0 from "./NeedSomething.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports